const getSessionStorageItem = (key: string): string | null => {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) {
      return null;
    }
    
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

const setSessionStorageItem = (key: string, value: string): void => {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) {
      return;
    }
    
    window.sessionStorage.setItem(key, value);
  } catch {
    // Silently fail if session storage is not available
  }
};

const removeSessionStorageItem = (key: string): void => {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) {
      return;
    }
    
    window.sessionStorage.removeItem(key);
  } catch {
    // Silently fail if session storage is not available
  }
};

export default {
  getSessionStorageItem,
  setSessionStorageItem,
  removeSessionStorageItem
};